import React from 'react';
import { withRouter } from 'react-router-dom';
import { withFormik } from 'formik';
import * as yup from 'yup';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import Input from '../../components/Input/Input';

const Form = ({
  loading,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  setFieldValue,
}) => (
  <form onSubmit={handleSubmit}>
    <Grid container spacing={3}>
      {formFields.map((field, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <Input
            {...field.config}
            elementType={field.elementType}
            value={values[field.config.name]}
            onChange={field.elementType === 'timePicker' ? setFieldValue : handleChange}
            onBlur={handleBlur}
            required
            fullWidth
            error={errors[field.config.name] && touched[field.config.name]}
            helperText={
              (touched[field.config.name] && errors[field.config.name]) || field.helperText
            }
          />
        </Grid>
      ))}
      <Grid item container justify="center">
        <Grid item xs={5}>
          <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
            {loading ? <CircularProgress size={20} color="primary" /> : 'CADASTRAR'}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  </form>
);

const formFields = [
  {
    elementType: 'timePicker',
    config: {
      name: 'time',
      label: 'Horário do Ponto',
      isFormik: true,
    },
    helperText: ' ',
  },
  {
    elementType: 'input',
    config: {
      type: 'text',
      name: 'justification',
      label: 'Justificativa',
    },
    helperText: ' ',
  },
  {
    elementType: 'select',
    config: {
      name: 'type',
      label: 'Tipo',
      options: [{ value: 'I', displayValue: 'Entrada' }, { value: 'O', displayValue: 'Saída' }],
    },
  },
];

const CreateTimeClockForm = withFormik({
  mapPropsToValues: props => ({
    time: '',
    justification: '',
    type: '',
  }),
  validationSchema: yup.object().shape({
    time: yup
      .string()
      .matches(/\d\d:\d\d/)
      .required(),
    justification: yup.string().required(),
    type: yup.string().required(),
  }),
  handleSubmit: (values, { props }) => {
    const timeclock = {
      justification: values.justification,
      employeeId: props.employeeId,
      newRegister: `${props.date} ${values.time.format('HH:mm')}`,
      type: values.type,
      category: 'INS',
    };
    props
      .onCreateTimeClock(timeclock)
      .then(response => props.history.push(`/pontos/${props.employeeId}`))
      .catch(error => error);
  },
})(Form);

export default withRouter(CreateTimeClockForm);
